import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { planEnrollmentService } from "./service";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;

export const getPlanEnrollment = async (
  planEnrollmentId: string
): Promise<IPlanEnrollment> => {
  const { data } = await planEnrollmentService.get(`/${planEnrollmentId}`);
  return data;
};
